module.exports = __webpack_public_path__ + "static/media/finsa.98405ca2.png";